import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { ICON_SIZE, INFO_WITH_ICONS_MARGIN } from '../../constants';
import { getPx } from '../../helpers/common';
import { ellipsisStyle } from '../../tokens/ellipsis';
import { InfoWithIconsPlaceholder } from './components/InfoWithIconsPlaceholder';
import { InfoWithIconsWrapper } from './components/InfoWithIconsWrapper';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../helpers/media-style';
var IconPlaceholderLeft = styled(InfoWithIconsPlaceholder)(_templateObject(), function (_ref) {
  var $iconMargin = _ref.$iconMargin,
      $noMargin = _ref.$noMargin,
      $vertical = _ref.$vertical;
  return styleArrayForBreakpoints([$iconMargin, $noMargin, $vertical], function (_ref2) {
    var $iconMargin = _ref2[0],
        $noMargin = _ref2[1],
        $vertical = _ref2[2];
    return $vertical ? "margin-bottom: " + getPx($noMargin ? 0 : $iconMargin) + ";" : "margin-right: " + getPx($noMargin ? 0 : $iconMargin) + ";";
  });
});
var IconPlaceholderRight = styled(InfoWithIconsPlaceholder)(_templateObject2(), function (_ref3) {
  var $iconMargin = _ref3.$iconMargin,
      $noMargin = _ref3.$noMargin,
      $vertical = _ref3.$vertical;
  return styleArrayForBreakpoints([$iconMargin, $noMargin, $vertical], function (_ref4) {
    var $iconMargin = _ref4[0],
        $noMargin = _ref4[1],
        $vertical = _ref4[2];
    return $vertical ? "margin-top: " + getPx($noMargin ? 0 : $iconMargin) + ";" : "margin-left: " + getPx($noMargin ? 0 : $iconMargin) + ";";
  });
});
var ChildrenWrapper = styled.span(_templateObject3(), function (_ref5) {
  var $withOverflowHidden = _ref5.$withOverflowHidden;
  return $withOverflowHidden ? "overflow: hidden;" : '';
}, function (_ref6) {
  var $fullWidth = _ref6.$fullWidth,
      $vertical = _ref6.$vertical;
  return styleForBreakpoints($vertical, function ($vertical) {
    return !$vertical && $fullWidth ? "flex-grow: 1;" : '';
  });
}, function (_ref7) {
  var $ellipsis = _ref7.$ellipsis,
      $vertical = _ref7.$vertical;
  return styleForBreakpoints($vertical, function ($vertical) {
    return !$vertical && $ellipsis ? "\n          overflow: hidden;\n          min-width: 0;\n          display: inline-block;\n          " + ellipsisStyle + "\n        " : '';
  });
}, function (_ref8) {
  var $noDisplay = _ref8.$noDisplay;
  return styleForBreakpoints($noDisplay, function ($noDisplay) {
    return $noDisplay ? "display: none;" : '';
  });
});

var InfoWithIconsSimple = function InfoWithIconsSimple(_ref9) {
  var _Component$_size, _Component$_size2;

  var _ref9$ellipsis = _ref9.ellipsis,
      ellipsis = _ref9$ellipsis === void 0 ? false : _ref9$ellipsis,
      _ref9$fullWidth = _ref9.fullWidth,
      fullWidth = _ref9$fullWidth === void 0 ? false : _ref9$fullWidth,
      _ref9$fullInnerWidth = _ref9.fullInnerWidth,
      fullInnerWidth = _ref9$fullInnerWidth === void 0 ? false : _ref9$fullInnerWidth,
      _ref9$withInnerOverfl = _ref9.withInnerOverflowHidden,
      withInnerOverflowHidden = _ref9$withInnerOverfl === void 0 ? false : _ref9$withInnerOverfl,
      _ref9$multiline = _ref9.multiline,
      multiline = _ref9$multiline === void 0 ? false : _ref9$multiline,
      lineHeight = _ref9.lineHeight,
      icon = _ref9.icon,
      iconRight = _ref9.iconRight,
      _ref9$iconMargin = _ref9.iconMargin,
      iconMargin = _ref9$iconMargin === void 0 ? INFO_WITH_ICONS_MARGIN : _ref9$iconMargin,
      _ref9$iconRightMargin = _ref9.iconRightMargin,
      iconRightMargin = _ref9$iconRightMargin === void 0 ? INFO_WITH_ICONS_MARGIN : _ref9$iconRightMargin,
      _ref9$iconWidth = _ref9.iconWidth,
      iconWidth = _ref9$iconWidth === void 0 ? ICON_SIZE : _ref9$iconWidth,
      _ref9$iconRightWidth = _ref9.iconRightWidth,
      iconRightWidth = _ref9$iconRightWidth === void 0 ? ICON_SIZE : _ref9$iconRightWidth,
      _ref9$iconHeight = _ref9.iconHeight,
      iconHeight = _ref9$iconHeight === void 0 ? ICON_SIZE : _ref9$iconHeight,
      _ref9$iconRightHeight = _ref9.iconRightHeight,
      iconRightHeight = _ref9$iconRightHeight === void 0 ? ICON_SIZE : _ref9$iconRightHeight,
      iconTopPosition = _ref9.iconTopPosition,
      iconRightTopPosition = _ref9.iconRightTopPosition,
      _ref9$vertical = _ref9.vertical,
      vertical = _ref9$vertical === void 0 ? false : _ref9$vertical,
      _ref9$noChildren = _ref9.noChildren,
      noChildren = _ref9$noChildren === void 0 ? false : _ref9$noChildren,
      Component = _ref9.component,
      children = _ref9.children,
      props = _objectWithoutPropertiesLoose(_ref9, ["ellipsis", "fullWidth", "fullInnerWidth", "withInnerOverflowHidden", "multiline", "lineHeight", "icon", "iconRight", "iconMargin", "iconRightMargin", "iconWidth", "iconRightWidth", "iconHeight", "iconRightHeight", "iconTopPosition", "iconRightTopPosition", "vertical", "noChildren", "component", "children"]);

  return icon || iconRight ? /*#__PURE__*/React.createElement(InfoWithIconsWrapper, _extends({
    $vertical: vertical,
    $fullWidth: fullWidth
  }, props), icon && /*#__PURE__*/React.createElement(IconPlaceholderLeft, {
    $vertical: vertical // @ts-expect-error Special type
    ,
    $lineHeight: lineHeight != null ? lineHeight : Component == null ? void 0 : (_Component$_size = Component._size) == null ? void 0 : _Component$_size.lineHeight,
    $multiline: multiline,
    $noMargin: noChildren,
    $iconMargin: iconMargin,
    $iconWidth: iconWidth,
    $iconHeight: iconHeight,
    $iconTopPosition: iconTopPosition
  }, icon), /*#__PURE__*/React.createElement(ChildrenWrapper, {
    $noDisplay: noChildren,
    $vertical: vertical,
    $fullWidth: fullInnerWidth,
    $withOverflowHidden: withInnerOverflowHidden,
    $ellipsis: ellipsis
  }, children), iconRight && /*#__PURE__*/React.createElement(IconPlaceholderRight, {
    $vertical: vertical // @ts-expect-error Special type
    ,
    $lineHeight: lineHeight != null ? lineHeight : Component == null ? void 0 : (_Component$_size2 = Component._size) == null ? void 0 : _Component$_size2.lineHeight,
    $multiline: multiline,
    $noMargin: noChildren,
    $iconMargin: iconRightMargin,
    $iconWidth: iconRightWidth,
    $iconHeight: iconRightHeight,
    $iconTopPosition: iconRightTopPosition
  }, iconRight)) : children;
};

export default InfoWithIconsSimple;